import AddButton from "../../components/buttons/AddButton";
import Dashboard from "../../components/Dashboard";
import Table from "../../components/Table";
import { MdPersonAddAlt1 } from "react-icons/md";

import AddClinic from "../../components/forms/AddClinic";
import { useForm } from "../../context/formContext";
import { HttpClient } from "../../Redux/controllers/HttpClient";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ClinicModal from "../../components/Modals/ClinicModal";
import { useModal } from "../../context/modalContext";
import { Spinner } from "@material-tailwind/react";
import {
  getMroAssociateTableData,
  getOrganizationTableData,
  organizationTableHeadData,
} from "../../constants/data/organizationData";
import AddOrganization from "../../components/forms/AddOrganization";
import OrganizationModal from "../../components/Modals/OrganizationModal";

const PhysicOrganization = () => {
  const { showForm, openForm, closeForm } = useForm();
  const { showEditModal, showModal, openModal, closeModal, closeEditModal } =
    useModal();
  const [showSpin, setShowSpin] = useState(false);
  const { token } = useSelector((state) => state.user);
  const [orgTableData, setOrgTableData] = useState([]);
  const [associates, setAssociates] = useState([]);
  const userDetail = useSelector(
    (state) => state?.user?.userInfo?.data?.user?._id
  );
  useEffect(() => {
    const fetchData = async () => {
      setShowSpin(true);
      try {
        const { data } = await HttpClient.apiCaller(
          `admin/get-users-createdby/${userDetail}?user_type=organization`,
          "GET",
          null,
          token,
          null
        );
        // console.log("//////////////////", data.user);
        setOrgTableData(data.user);
      } catch (error) {
        console.log(error);
      } finally {
        setShowSpin(false);
      }
    };

    fetchData();

    return () => {};
  }, [closeForm, closeEditModal]);
  useEffect(() => {
    const fetchData = async () => {
      setShowSpin(true);
      try {
        const { data } = await HttpClient.apiCaller(
          `admin/my-associates/${userDetail}`,
          "GET",
          null,
          token,
          null
        );
        // console.log("//////////////////", data.user);
        setAssociates(data?.employers);
      } catch (error) {
        console.log(error);
      } finally {
        setShowSpin(false);
      }
    };

    fetchData();

    return () => {};
  }, [closeForm, closeEditModal]);
  return (
    <Dashboard>
      {showForm ? (
        <AddOrganization onClose={closeForm} />
      ) : (
        <>
          {" "}
          <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5">
            <div>
              <p className="poppins-medium  leading-[21px]  text-gray-700 mb-2">
                List of Organizations
              </p>
              <p className="poppins-regular text-xs text-[#B5B5C3] ">
                {orgTableData?.length} available Organizations
              </p>
            </div>
            {/*  */}
            <AddButton
              onClick={openForm}
              buttonName={"Add New Organization"}
              icon={<MdPersonAddAlt1 className="size-5" />}
            />
          </div>
          {/*  table */}
          {showSpin ? (
            <div className="w-full mt-20 flex items-center justify-center">
              <Spinner className="h-12 w-12" />{" "}
            </div>
          ) : (
            <Table
              tableData={getOrganizationTableData(orgTableData)}
              tableHeadData={organizationTableHeadData}
            />
          )}
          {associates?.length !== 0 &&
            associates[0]?.user_type === "organization" && (
              <>
                <div className="flex xs:flex-col-reverse xs:gap-2 sm:flex-row sm:items-center sm:justify-between mb-5 mt-10">
                  <div>
                    <p className="poppins-medium  leading-[21px]  text-gray-700 mb-2">
                      My Associated Organizations
                    </p>
                    <p className="poppins-regular text-xs text-[#B5B5C3] ">
                      {associates?.length} available Organizations
                    </p>
                  </div>
                </div>
                {showSpin ? (
                  <div className="w-full mt-20 flex items-center justify-center">
                    <Spinner className="h-12 w-12" />{" "}
                  </div>
                ) : (
                  <Table
                    tableData={getMroAssociateTableData(associates)}
                    tableHeadData={organizationTableHeadData}
                  />
                )}
              </>
            )}
        </>
      )}
      {/*Edit modal */}
      {showEditModal ? (
        <OrganizationModal edit={true} onClose={closeEditModal} />
      ) : (
        <></>
      )}
    </Dashboard>
  );
};

export default PhysicOrganization;
